import { styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .super-app-theme": {
    backgroundColor: "#f5fafb",
    color: theme.palette.text.secondary,
    borderRadius: "8px",

    "&:hover": {
      backgroundColor: "#e8f1f3",
    },
    "&.Mui-selected": {
      backgroundColor: "#f5fafb",
      "&:hover": {
        backgroundColor: "#e8f1f3",
      },
    },
  },

  "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
    border: "none",
  },

  "& .super-app-theme--cell": {
    border: "none",
    borderBottom: "none",
  },

  "& .MuiDataGrid-row": {
    marginTop: "5px",
    marginBottom: "5px",
    backgroundColor: "#f5fafb",
    borderRadius: "8px",
    overflow: "hidden",
  },

  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },

  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
    outline: "none",
  },

  "& .super-app-theme--header": {
    backgroundColor: "white",
    color: theme.palette.text.secondary,
  },

  backgroundColor: "white",
  padding: "10px",
}));

export default StyledDataGrid;
